module.exports = {
  assetPrefix: `/pages`,
  trailingSlash: `ignore`,
  siteMetadata: {
    baseUrl: `https://crunchyroll.com`,
    url: `https://crunchyroll.com/pages`,
    title: `Your favorite anime.`,
    description: `All your favorite anime in one great place!`,
    banner: {
      url: `https://crunchyroll.com/pages/default-banner.jpg`,
      width: `1080`,
      height: `565`,
    },
  },
  plugins: [
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-plugin-emotion`,
    `gatsby-plugin-react-helmet`,
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
  ],
}
